import { render, staticRenderFns } from "./about-order.vue?vue&type=template&id=73dc87b5&scoped=true"
import script from "./about-order.vue?vue&type=script&lang=js"
export * from "./about-order.vue?vue&type=script&lang=js"
import style0 from "./about-order.vue?vue&type=style&index=0&id=73dc87b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73dc87b5",
  null
  
)

export default component.exports